const locationHost = window.location.host;
const portalHost = locationHost.split('.').slice(1).join('.');
// console.log('locationUrl', locationHost);
// console.log('portalHost', portalHost);

const startScript = () => {
  const initScript = document.createElement('script');
  let currentUrl = `https://${portalHost}`;
  if (locationHost.indexOf('localhost') !== -1) currentUrl = 'https://uat.sk.ru';
  initScript.textContent = `SK.init({ originPath: "${currentUrl}" })`;
  document.querySelector('body').prepend(initScript);
};

export const insertHeader = () => {
  const currentPath = window.location.href;
  if (currentPath.search('/new-projects') !== -1) return;
  // check if inserted
  const scripts = document.getElementsByTagName('script');
  const newDate = (new Date()).toISOString().split('T')[0].split('-').join('');
  let scriptUrl = `https://menu.${portalHost}/sk-header-menu.bundle.js?${newDate}`;
  if (locationHost.indexOf('localhost') !== -1) {
    scriptUrl = `https://menu.uat.sk.ru/sk-header-menu.bundle.js?${newDate}`;
  }
  // console.log('scriptUrl', scriptUrl);
  for (let i = 0; i < scripts.length; i += 1) {
    if (scripts[i].src === scriptUrl) {
      // console.log('script already inserted');
      startScript();
      return;
    }
  }
  // insert menu script
  const component = document.createElement('script');
  component.setAttribute('src', scriptUrl);
  component.async = true;
  document.querySelector('body').prepend(component);
  // insert initialization
  component.onload = () => {
    startScript();
  };
};
